import { LoggerOptions } from 'pino'
import P from 'pino'

const loggerOptions: LoggerOptions = {
  name: 'cashrewards-accounts',
  prettyPrint: { colorize: true, levelFirst: true },
  level: 'info',
}
export const logger = P(loggerOptions)
